import { Card, Empty, Flex, Progress, Typography } from "antd";

import "./DeficientProjects.scss";
import { MessageFilled } from "@ant-design/icons";
import variables from "../../../_variables.scss";
import { utilityService } from "shared/services";
import { Link } from "react-router-dom";
import { IDeficientProject } from "projects/models";
import { useBoundStore } from "store";

interface DeficientProjectsProps {
  deficientProjects: IDeficientProject[];
}

export const DeficientProjects = ({ deficientProjects }: DeficientProjectsProps) => {
  const hasData = deficientProjects?.length > 0;
  const { tenant, currentOrganization } = useBoundStore();

  return (
    <Flex vertical gap={variables.gap} data-testid='deficientProjects'>
      <h2>Deficient Projects</h2>
      {hasData ? (
        <Flex gap={variables.gap} wrap>
          {deficientProjects?.map((p) => (
            <Card
              className='deficient-projects-card'
              key={p.name}
              style={{ width: "32.5%" }}
            >
              <Flex vertical gap={variables.smallGap}>
                <Typography.Text className='deficient-projects-card-title'>
                  <Link to={`/${tenant?.id}/organizations/${currentOrganization?.id}/projects/${p.id}`}>{p.name}</Link>
                </Typography.Text>
                <Typography.Text className='deficient-projects-card-subtitle'>
                  {p.projectCode?.toUpperCase()}
                </Typography.Text>
                {p.latestProjectNote?.content && (
                  <Typography.Text className='deficient-projects-card-note'>
                    <MessageFilled />{" "}
                    <div
                      dangerouslySetInnerHTML={{
                        __html: utilityService.truncateHtml(
                          p.latestProjectNote.content as string
                        ),
                      }}
                    />
                  </Typography.Text>
                )}
                <Progress
                  percent={p.percent}
                  showInfo={false}
                  status='exception'
                />
                <Typography.Text>
                  <Typography.Text strong>{p.daysOverdue}</Typography.Text> Days
                  Overdue
                </Typography.Text>
                <Typography.Text>
                  <Typography.Text strong>Stage:</Typography.Text> {p.stage}
                </Typography.Text>
              </Flex>
            </Card>
          ))}
        </Flex>
      ) : (
        <Empty />
      )}
    </Flex>
  );
};
